/**
 * Copyright © 2025-2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Outlet, RouteObject } from "react-router-dom";

import { ProtectedRoute } from "../../components/AppRouter/ProtectedRoute";
import { FlagGate, SelectorGate } from "../../components/AppRouter/route-gates";
import { SeedOrder } from "../../pages/SeedOrder";
import { SeedOrderSuccess } from "../../pages/SeedOrderSuccess";
import { HOME_ROUTE } from "../../util/routing";
import { selectCanUseQuickOrder } from "../azure-b2c/storage";

import { SEED_ROUTES, SEED_SUCCESS_ROUTE, SEED_SUMMARY_ROUTE } from "./constants";
import { SeedOrderSummary } from "./SeedOrderSummary";

export const seedRoutes: RouteObject[] = [
  {
    element: (
      <FlagGate flag="seedEnabled" redirectTo={HOME_ROUTE}>
        <ProtectedRoute mode="single" permission="Orders_SeedOrderCreate" redirectTo={HOME_ROUTE}>
          <Outlet />
        </ProtectedRoute>
      </FlagGate>
    ),
    children: [
      { path: SEED_ROUTES.BASE, element: <SeedOrder /> },
      {
        element: <SelectorGate selector={selectCanUseQuickOrder} redirectTo={HOME_ROUTE} />,
        children: [
          { path: SEED_SUMMARY_ROUTE, element: <SeedOrderSummary /> },
          { path: SEED_SUCCESS_ROUTE, element: <SeedOrderSuccess /> },
        ],
      },
    ],
  },
];
